import React, { useState, useEffect } from 'react';
import Section from './Tabs/Section';
import Modal from 'react-modal';
import { jsPDF } from 'jspdf';
import {
  getOasisData,
  getSections,
  getCommentCards,
  getFileNames,
  searchUserReferral,
} from '../api';
import { extractReferralId } from '../Utility';
import Export from './Export';
import Footer from './Footer';
import Loading from './Loading';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import logo from '../connect_logo.png';

const customStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
  content: {
    minWidth: '400px',
    width: '800px',
    minHeight: '400px',
    height: '800px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: '8px',
  },
};

const Oasis = () => {
  const [selectedSection, setSelectedSection] = useState('');
  const [sideNavCollapsed, setSideNavCollapsed] = useState(false);
  const [commentCards, setCommentCards] = useState([]);
  const [oasisData, setOasisData] = useState([]);
  const [unfilteredOasisData, setUnfilteredOasisData] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [sections, setSections] = useState([]);
  const [referralId, setReferralId] = useState('');
  const [fileNames, setFileNames] = useState([]);
  const [selectedFile, setSelectedFile] = useState([]);
  const [searchId, setSearchId] = useState('');
  const [referrals, setReferrals] = useState([]);
  const [selectedReferral, setSelectedReferral] = useState('');
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [formattedOasisData, setFormattedOasisData] = useState([]);
  const [selectedReferralLabel, setSelectedReferralLabel] = useState('');

  const populateComponent = async (initialReferralId = '') => {
    let fileNames, OasisData, cards;
    const response = await getSections();
    const sectionsData = response?.resgg?.sections || [];

    let selectedReferralLabel;
    let idToUse = initialReferralId || searchId;

    if (idToUse) {
      fileNames = await getFileNames(idToUse);
      OasisData = await getOasisData(idToUse);

      if (fileNames.length > 0) {
        cards = await getCommentCards(idToUse, fileNames[0]);
      } else {
        cards = [];
      }

      const firstNameObj = OasisData?.mapItems.find(
        (item) => item.shortLabel === "Patient's first name"
      );
      const lastNameObj = OasisData?.mapItems.find(
        (item) => item.shortLabel === "Patient's last name"
      );
      const dobObj = OasisData?.mapItems.find(
        (item) => item.shortLabel === 'Date of birth'
      );

      if (firstNameObj && lastNameObj && dobObj) {
        selectedReferralLabel = `${lastNameObj.textValue}, ${firstNameObj.textValue}, ${dobObj.textValue}`;
      } else {
        selectedReferralLabel = 'None Selected';
      }

      const DataByFile = OasisData.mapItems?.filter(
        (x) => x.fileName === fileNames[0]
      );

      const comments = cards.commentCards ? cards.commentCards : [];
      const formattedOasis = organizeOasisData(DataByFile);
      setCommentCards(comments);
      setOasisData(DataByFile);
      setUnfilteredOasisData(OasisData?.mapItems);
      setFileNames(fileNames);
      setSelectedFile(fileNames[0]);
      setSearchId(idToUse);
      setReferralId(idToUse);
      setSelectedReferralLabel(selectedReferralLabel);
      setFormattedOasisData(formattedOasis);
      setSelectedReferral('');
      const url = new URL(window.location.href);
      url.searchParams.delete('referralId');
      window.history.pushState({}, '', url);
    } else {
      setSelectedReferral('');
      setCommentCards([]);
      setOasisData([]);
      setUnfilteredOasisData([]);
      setFileNames([]);
      setSelectedFile('');
      setSearchId('');
      setReferralId('');
      setSelectedReferralLabel('None Selected');
      setFormattedOasisData([]);
      setSelectedSection(sectionsData[0]?.itemSectionLabel);
      setSections(sectionsData);
      setIsLoaded(true);

      const url = new URL(window.location.href);
      url.searchParams.delete('referralId');
      window.history.pushState({}, '', url);
      return;
    }
    const selectedSection = sectionsData[0]?.itemSectionLabel;

    // Update state
    setSections(sectionsData);
    setSelectedSection(selectedSection);
    setIsLoaded(true);
  };

  const organizeOasisData = (oasis) => {
    return oasis?.reduce((acc, obj) => {
      if (obj.sectionLabel === 'Control') return acc; // Skip if 'Control'

      // Initialize the section array if it doesn't exist, then push the object
      acc[obj.sectionLabel] = acc[obj.sectionLabel] || [];
      acc[obj.sectionLabel].push(obj);

      return acc;
    }, {});
  };

  const handleTabSelect = (selectedSection) => {
    setSelectedSection(selectedSection);
  };

  const updateCards = async (newCards) => {
    setCommentCards(newCards);
  };

  const handleReferralSelect = async (option) => {
    setSelectedReferral(option);
    setSearchId(option.value);

    setIsLoaded(false);
    populateComponent(option.value);
  };

  const loadOptions = async (inputValue) => {
    if (inputValue.length >= 3) {
      const results = await searchUserReferral(inputValue);

      if (results.length === 0) {
        return [{ value: '', label: 'No Results Found' }];
      }

      const options = results.map((referral) => ({
        value: referral.referralId,
        label: `${referral.lastName}, ${referral.firstName}, ${referral.dateOfBirth}`,
      }));

      setReferrals(options);
      return options;
    }
    return [];
  };

  const convertFilesToSelect = () => {
    var selectFileNames = [];
    fileNames.forEach((fileName) => {
      selectFileNames.push({ value: fileName, label: fileName });
    });

    return selectFileNames;
  };
  const fileOptions = convertFilesToSelect();

  const selectedFileOption = fileOptions.find(
    (option) => option.value === selectedFile
  );
  const handleSelectFileName = async (option) => {
    setIsLoaded(false);

    const DataByFile = unfilteredOasisData.filter(
      (x) => x.fileName === option.value
    );

    const cards = await getCommentCards(searchId, option.value);
    setSelectedFile(option.value);
    setOasisData(DataByFile);
    setCommentCards(cards.commentCards);
    setIsLoaded(true);
  };

  const search = async () => {
    setIsLoaded(false);
    populateComponent(searchId);
  };

  const handleSearchChange = (event) => {
    setSearchId(event.target.value);
  };

  const exportPDF = () => {
    const el = document.getElementById('export');
    let doc = new jsPDF('portrait', 'pt', 'a4');

    doc.html(el, {
      callback: function (doc) {
        doc.save('oasis.pdf');
      },
      html2canvas: { scale: 0.75 },
      margin: [10, 10, 20, 20],
    });
  };

  useEffect(() => {
    const searchReferralId = extractReferralId(window.location.search);
    populateComponent(searchReferralId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isLoaded) {
    return <Loading />;
  }

  return (
    <div>
      <nav className='top-nav w-100 d-flex justify-content-between align-items-center flex-row p-3 position-relative'>
        <img src={logo} alt='' className='nav-logo' />

        <p className='nav-title'>
          Outcome and Assessment Information Set - Oasis
        </p>
        <div className='w-30'></div>
      </nav>
      <nav className='bottom-nav row border-bottom p-3'>
        <div className='d-flex flex-row justify-content-between'>
          <div className='d-flex'>
            <label htmlFor='search' className='ms-4 me-2'>
              Referral Id:{' '}
            </label>
            <input
              id='search'
              className='form-control noselect me-1'
              style={{ maxWidth: '125px', borderRadius: '8px' }}
              unselectable='on'
              type='text'
              name='searchId'
              value={searchId}
              onChange={handleSearchChange}
              maxLength={6}
            ></input>

            <button
              className='phcn-btn primary me-3'
              name='search'
              onClick={search}
              data-testid='search-button'
            >
              Search
            </button>
          </div>
          <div className='d-flex align-items-center'>
            {/* Display selected referral label */}
            <div className='ms-3 me-2'>
              <b className='font-weight-bold'>Member:</b>{' '}
              {selectedReferralLabel}
            </div>
          </div>
          <div className='d-flex'>
            <label htmlFor='selectReferral' className='ms-3 me-2'>
              Search:{' '}
            </label>
            <AsyncSelect
              cacheOptions
              id='selectReferral'
              loadOptions={loadOptions}
              value={selectedReferral}
              onChange={handleReferralSelect}
              options={referrals}
              className='async-dropdown'
              defaultOptions
            />
          </div>
          <div className='d-flex'>
            <label className='fileSelect ms-2 me-2'>Oasis File: </label>
            <div style={{ width: '200px' }}>
              <Select
                closeMenuOnSelect={true}
                data-testid='fileSelect'
                hideSelectedOptions={false}
                placeholder='Select File'
                name='files'
                options={fileOptions}
                value={selectedFileOption}
                className='basic-single'
                classNamePrefix='select'
                onChange={handleSelectFileName}
              />
            </div>
          </div>
          <i
            className='fas fa-download align-self-center'
            onClick={() => {
              setExportModalOpen(true);
            }}
          ></i>
        </div>
      </nav>
      <div className='container-fluid px-0'>
        <div className='d-flex'>
          <div
            className={`flex-fill side-nav-${
              sideNavCollapsed ? 'closed' : 'open'
            }`}
          >
            <div
              className='nav flex-column nav-tabs py-4 ps-3 h-100'
              id='v-pills-tab'
              role='tablist'
              aria-orientation='vertical'
            >
              <div
                className='clickable-div side-collapse-button'
                onClick={() => {
                  setSideNavCollapsed(!sideNavCollapsed);
                }}
              >
                <i
                  className={`fas fa-angle-double-${
                    sideNavCollapsed ? 'right' : 'left'
                  }`}
                ></i>
              </div>

              {sections.map((section, index) => (
                <div
                  key={section.itemSectionLabel}
                  className={`${
                    index === 0 ? 'mt-40 ' : ''
                  }clickable-div nav-link ${
                    selectedSection === section.itemSectionLabel ? 'active' : ''
                  }`}
                  onClick={() => {
                    handleTabSelect(section.itemSectionLabel);
                  }}
                >
                  {section.itemSectionLabel}
                </div>
              ))}
            </div>
          </div>

          <div className='d-flex flex-column w-100'>
            <div className='flex-grow-1 min-vh-100'>
              <Section
                data={oasisData.filter(
                  (x) => x.sectionLabel === selectedSection
                )}
                section={selectedSection}
                selectedFile={selectedFile}
                commentCards={commentCards?.filter(
                  (x) => x.itemSectionLabel === selectedSection
                )}
                referralId={searchId}
                selectedReferral={selectedReferral}
                updateCards={updateCards}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={exportModalOpen}
        onRequestClose={() => {
          setExportModalOpen(false);
        }}
        contentLabel='Export Oasis Data'
        style={customStyles}
        overlayClassName='myoverlay'
      >
        <div
          className='d-flex justify-content-between align-items-center'
          style={{ marginLeft: '90%', width: '50px', marginTop: '20px' }}
        >
          <i
            className='fas fa-download align-self-center'
            onClick={exportPDF}
          ></i>
          <i
            className='fas fa-times align-self-center'
            onClick={() => {
              setExportModalOpen(false);
            }}
          ></i>
        </div>

        <Export
          data={formattedOasisData}
          referralId={referralId}
          comments={commentCards}
        />
        <div className='d-flex mt-3 mb-3 justify-content-center'>
          <button
            onClick={exportPDF}
            className='btn btn-primary modal-confirm-button'
            data-testid='export-confirm'
          >
            Export
          </button>
          <button
            onClick={() => {
              setExportModalOpen(false);
            }}
            className='btn btn-primary modal-close-button'
            data-testid='export-cancel'
            style={{ marginLeft: '10px' }}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Footer />
    </div>
  );
};

export default Oasis;
